import { combineReducers } from 'redux';
import { dashboard } from './dashboard';
import { authentication } from './authentication'

export default combineReducers({
   dashboard,
   authentication
});